export default __webpack_public_path__ + "static/media/SDM-new.cf89ce89.png";